var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-308 -27)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(308 27)",
    fill: "#25af60"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(332 37) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.227,8.767a.76.76,0,0,0,1.008.077l.087-.077L8,1.918l6.678,6.85a.76.76,0,0,0,1.008.077l.087-.077a.81.81,0,0,0,.075-1.034l-.075-.089L8.547.233A.76.76,0,0,0,7.539.156L7.453.233.227,7.644A.809.809,0,0,0,.227,8.767Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.226,9.5a1.256,1.256,0,0,1-.905-.384L8,2.634,1.653,9.142l-.116.1A1.26,1.26,0,0,1-.131,9.116a1.313,1.313,0,0,1,0-1.821L7.121-.142l.116-.1A1.268,1.268,0,0,1,8-.5a1.256,1.256,0,0,1,.905.384l7.25,7.439.1.118a1.3,1.3,0,0,1-.122,1.676l-.027.025-.115.1A1.268,1.268,0,0,1,15.226,9.5ZM8,1.2l7.036,7.217a.263.263,0,0,0,.189.082.258.258,0,0,0,.147-.045l.052-.046a.309.309,0,0,0,.026-.37L15.4,7.98,8.189.582A.263.263,0,0,0,8,.5a.258.258,0,0,0-.147.045L7.8.595.585,7.993a.31.31,0,0,0,0,.425A.263.263,0,0,0,.774,8.5a.258.258,0,0,0,.147-.045l.056-.049Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrow_green.929f63932ff8093ac64911b6df132c57.svg";
export { ForwardRef as ReactComponent };